export { default } from "./AllPagesWrapper";
